export const roles = {
    USER: 'user',
    MANAGER: 'manager',
    ADMIN: 'admin',
    VIEWER: 'spectator'
}
